import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import LinkAndAnchor from './LinkAndAnchor';
import SiteContext from './SiteContext';
import messages from '../lib/messages';

const HomeLink = () => {
  const intl = useIntl();
  const { hasNews, lite } = useContext(SiteContext);

  return (
    <LinkAndAnchor
      key="home"
      route="index"
      passHref
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      useRouter={hasNews || lite}
    >
      {intl.formatMessage(messages.home)}
    </LinkAndAnchor>
  );
};

export default HomeLink;
